module.exports = __webpack_public_path__ + "static/landingpage_icons_v2-08-bb2bab1fb9a821dd8358fff91730bbfe.png";